import {useCallback} from 'react';

export const useErrorHandler = (hookOptions = {}) => {
    /**
     * Error handler
     *
     * En la función se define el flujo de la aplicación en caso de un error.
     *
     * @param {String | Object | Error} error
     * @returns {String[2]}
     *
     */
    const handleError = useCallback((err, options) => {
        const errors = err?.response?.data?.errors;
        if (!!errors && errors.length > 0) {
            return [errors[0].message, '']
        } else {
            return ['fetch error', '']
        }
    }, []);

    return {
        handleError,
    };
};

